// extracted by mini-css-extract-plugin
export var heroAbout = "index-module--heroAbout--29XKJ";
export var background = "index-module--background--3A8PF";
export var hero = "index-module--hero--Vs5y-";
export var logo = "index-module--logo--1sFuY";